(() => {
  if (customElements.get('libero-laundry-preview')) return;
  const storageKey = 'libero:laundry-gift-design-preview';
  let selected = false;
  try { selected = sessionStorage.getItem(storageKey) === 'selected'; } catch {}
  const isRegularProduct = () => Boolean(document.querySelector('product-info[data-libero-regular-product]'));
  const setSelected = (value) => {
    const onlyChanged = isRegularProduct();
    if (onlyChanged && selected === value) return;
    selected = value;
    try { sessionStorage.setItem(storageKey, value ? 'selected' : ''); } catch {}
    document.querySelectorAll('libero-laundry-preview').forEach((element) => {
      if (onlyChanged && typeof element.render !== 'function') return;
      element.render();
    });
  };
  class LiberoLaundryPreview extends HTMLElement {
    connectedCallback() {
      if (window.Shopify?.theme?.role !== 'unpublished') {
        this.remove();
        return;
      }
      if (this.dataset.context === 'product') {
        if (!isRegularProduct() || this.hidden) this.hidden = false;
        return;
      }
      const hidden = this.dataset.eligible !== 'true';
      if (!isRegularProduct() || this.hidden !== hidden) this.hidden = hidden;
      if (this.hidden) setSelected(false);
      if (!this.bound) {
        this.addEventListener('click', (event) => {
          const add = event.target.closest('[data-gift-preview-add]');
          const remove = event.target.closest('[data-gift-preview-remove]');
          if (!add && !remove) return;
          event.preventDefault();
          if (add && selected) return;
          setSelected(Boolean(add));
          this.querySelector('[data-gift-preview-status]').textContent = add ? this.dataset.selectedMessage : this.dataset.removedMessage;
          if (remove) this.querySelector('[data-gift-preview-add]').focus();
        });
        this.bound = true;
      }
      this.render();
    }
    render() {
      if (this.dataset.context !== 'cart') return;
      const onlyChanged = isRegularProduct();
      const setHidden = (selector, hidden) => {
        const element = this.querySelector(selector);
        if (!onlyChanged || element.hidden !== hidden) element.hidden = hidden;
      };
      setHidden('[data-gift-preview-unselected]', selected);
      setHidden('[data-gift-preview-selected]', !selected);
      setHidden('[data-gift-preview-remove]', !selected);
      const addButton = this.querySelector('[data-gift-preview-add]');
      const disabled = String(selected);
      if (!onlyChanged || addButton.getAttribute('aria-disabled') !== disabled) {
        addButton.setAttribute('aria-disabled', disabled);
      }
    }
  }
  customElements.define('libero-laundry-preview', LiberoLaundryPreview);
})();
